module.exports = __webpack_public_path__ + "img/right-info-open-move.ab248bbd.png";